import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { getPathFromAlternativePaths } from '../../../../helpers';

import './style.scss';

const ParagraphPageTeaserLarge = ({ entity, className }) => {
  const classes = classNames(className, [
    'ParagraphPageTeaserLarge',
    'reversed',
  ]);

  const url = getPathFromAlternativePaths(entity);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="ParagraphPageTeaserLarge__content">
        <div className="ParagraphPageTeaserLarge__contentWrapper">
          <div className="node--sub-heading">
            <span>{i18next.t('page')}</span>
          </div>
          <h2>{entity.getIn(['title', 0, 'value'])}</h2>
          {entity.getIn(['body', 0, 'processed']) ? (
            <WysiwygField
              property="schema:text"
              className="node--page--body font-size--body--large"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default ParagraphPageTeaserLarge;
